<app-navbar title="Historia">
	<a routerLink="../history" class="btn btn-danger"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<app-dynamic-table
	[elements]="data"
	[tableRows]="tableRows"
	[haveFilters]="false"
	[haveLink]="false"
	module="tourismEventsDriversHistory"
></app-dynamic-table>
